import { applyStylePreservingInline } from './apply-style-preserving-inline';

export function applyFontSize(elements: HTMLElement[], enabled: boolean) {
  elements.forEach((elem) => {
    if (
      !(elem instanceof HTMLElement) ||
      !elem.isConnected ||
      !elem.dataset.eappsFontSize
    ) {
      return;
    }

    applyStylePreservingInline({
      element: elem,
      enabled,
      styleProperty: 'font-size',
      getValue: () => {
        const rawFontSize = elem.dataset.eappsFontSize;
        if (!rawFontSize) {
          return '1';
        }

        const prevFontSize = Number(rawFontSize);
        const increaseValue = prevFontSize > 70 ? 10 : 20;
        const newFontSize = (prevFontSize * (increaseValue + 100)) / 100;
        return `${newFontSize}px`;
      }
    });
  });
}
